import { WebStorageStateStore } from './oidcCompat'
import Config from '../../appconfig.json'

// Handle secrets: try VUE_APP_AUTH_SECRET env var first, then secrets.json, then fallback
let authSecret = process.env.VUE_APP_AUTH_SECRET || 'offline-mode-secret'
try {
  const secrets = require('../../secrets.json')
  if (secrets.authSecret) authSecret = secrets.authSecret
} catch (e) {
  // secrets.json not found or VUE_APP_AUTH_SECRET not set — using default
}

const origin = window.location.origin

export const oidcConfig = {
  authority: Config.platformEndpoints.authentication || Config.authentication.authority,
  client_id: Config.authentication.clientId,
  client_secret: authSecret,
  redirect_uri: `${origin}/auth/callback.html`,
  post_logout_redirect_uri: origin,
  response_type: 'code',
  scope: 'openid profile offline_access assetManagerApi IdentityServerApi workspace',
  monitorSession: false,
  automaticSilentRenew: true,
  includeIdTokenInSilentRenew: true,
  silent_redirect_uri: `${origin}/auth/silent-renew.html`,
  revokeTokensOnSignout: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
}
